export default function addressToString(address, short = false) {
  // let str = a.full; // city to house.
  const parts = [];
  let city = ''

  if (!short && address.city) {
    parts.push(address.city)
    city = address.city
  } else if (!short && address.settlement) {
    parts.push(address.settlement)
    city = address.settlement
  }

  if (address.street && address.street !== city) {
    parts.push(address.street);
  }

  if (address.house) {
    parts.push((short ? '' : 'д. ') + address.house);
  }

  if (address.block) {
    parts.push(address.block)
  }

  if (!short) {
    if (address.entrance) {
      parts.push(`под. ${address.entrance}`);
    }

    if (address.floor) {
      parts.push(`эт. ${address.floor}`);
    }
  }

  if (address.apartment) {
    parts.push((short ? '' : 'кв. ') + address.apartment);
  }

  return parts.join(', ');
}
